var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgWarningTriangle = function SvgWarningTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.167 15.832h11.666a1.668 1.668 0 001.534-2.291L11.45 3.332a1.666 1.666 0 00-2.917 0L2.617 13.541a1.667 1.667 0 001.458 2.291",
    fill: "#F4B718"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.167 15.832h11.666a1.668 1.668 0 001.534-2.291L11.45 3.332a1.666 1.666 0 00-2.917 0L2.617 13.541a1.667 1.667 0 001.458 2.291",
    stroke: "#F4B718",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.475v.008m0-2.993V5.993",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgWarningTriangle;